import { Reducer } from 'redux'
import { IGlnLocatieZoekState } from '../interfaces'
import { GlnLocatieZoekActions, Actions } from '../actions/glnLocatieZoekAction'

const initialState: IGlnLocatieZoekState = {
  loading: false,
  selectie: { locatieGln: undefined, locatieNaam: undefined },
  vestiging: undefined,
  locaties: [],
  foutmelding: undefined,
}

export const glnLocatieZoekReducer: Reducer<
  IGlnLocatieZoekState,
  GlnLocatieZoekActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetLocationsRequest:
      return {
        ...state,
        loading: true,
        selectie: action.payload,
        foutmelding: null,
      }
    case Actions.GetLocationsResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        locaties: action.success ? action.payload : null,
      }
    case Actions.ClearDataRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.ClearDataResponse:
      return {
        ...state,
        loading: false,
        locatie: null,
        locaties: [],
        foutmelding: action.success ? action.payload : action.errorMessage,
      }

    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
